// extracted by mini-css-extract-plugin
export default {"shopContainer":"index_shopContainer__NUwUn","followWeChat":"index_followWeChat__-NAno","jifenBoardWrap":"index_jifenBoardWrap__MbyjZ"};